import { Component, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AdministracionService } from '../../../data/services/admin/administracion.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PopupGenericActionComponent } from 'src/app/core/shared/popup-admin/popup-generic-action/popup-generic-action';
import { ChannelListResponse } from 'src/app/models/admin-models/channel.model';
import { LoggerService } from 'src/app/core/logger.service';

@Component({
    selector: 'app-administracion',
    templateUrl: './administracion.component.html',
    styleUrls: ['./administracion.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdministracionComponent {

  public filterValue: string = '';
  public channelsList: any[] = [];
  public activityButtons: boolean = false;
  public showPaginator: boolean = true;
  public filterRecords: number = 10;
  public rowsPerPageOptions: number[] = [10];
  public totalRecords: number = 0;
  // public firstElement: number = 0;
  // public isInitialLoad = true;
  public pageNumber: number = 1;
  public sideMenuVisible: boolean = false;
  public optionSort: {property: string | null, order: string} = {property: null, order: 'asc'};
  public currentPage = 1;


  constructor(
    private administracionService: AdministracionService,
    private router: Router,
    private dialog: MatDialog,
    private logger: LoggerService
  ) { }

  ngOnInit(): void {
    this.filterItems(null, 'channels', this.filterValue);
  }

  getCircleColor(estado: boolean) {
    switch (estado) {
      case true:
        return '#cff892';
      case false:
        return '#fe0002';
      default:
        return '#fe0002';
    }
  }

  setActive(item: any, activate: boolean) {

    const dialogRef = this.dialog.open(PopupGenericActionComponent, {
      data: {
        action: 'actDeactChannel',
        activate,
        channelName: item.name
      }
    });

    let itemSend: any = {};
    let itemsSend: any[] = [];

    dialogRef.afterClosed()
      .subscribe(res => {

        if(res){
          itemSend.id = item.id;
          itemSend.active = activate;
          itemsSend.push(itemSend);

          this.updateChannelState(itemsSend, activate);
        }

      });

  }

  setMultipleActive(active: boolean) {
    let itemsSend: any[] = [];
    const selectedItems = this.channelsList.filter(i => i.selected);
    selectedItems.forEach(item => {
      let itemSend: any = {};
      item.selected = active;
      itemSend.id = item.id;
      itemSend.active = active;
      itemsSend.push(itemSend);
    });

    this.updateChannelState(itemsSend, active);

  }

  updateChannelState(itemsSend: any[] = [], active: boolean) {
    this.administracionService.updateChannelState(itemsSend, active)
    .subscribe({
      next: (response: any) => {
        this.logger.debug('Estado del canal actualizado:', response);
        this.activityButtons = false;
        this.channelsList = this.channelsList.map(item => {
          const updatedItem = itemsSend.find(updated => updated.id === item.id);
          return updatedItem ? { ...item, active: updatedItem.active, selected: false } : item;
        });
      },
      error: (error: any) => {
        console.error('Error actualizando el estado del canal', error);
      }
    });
  }

  verDatos(item: any) {
    this.logger.debug('Ver datos clicado del item desde padre:' + item.name);
    this.router.navigateByUrl('channelDetail', { state: { canal: item, focus: "detalles" }});
  }

  verSubcanales(item: any) {
    this.logger.debug("VER SUBCANALES DEL CANAL QUE ESTOY LISTANDO -> " + item.name);
    //DEBERÍA ENTRASR EN EL POPUP PONIENDO EL FOCO EN LA PESTAÑA DE SUBCANALES
    this.logger.debug("DEBERÍA ENTRASR EN EL POPUP PONIENDO EL FOCO EN LA PESTAÑA DE SUBCANALES");
    this.router.navigateByUrl('channelDetail', { state: { canal: item, focus: "subcanales" }});
  }

  verMarcas(item: any) {
    //DEBERÍA ENTRASR EN EL POPUP PONIENDO EL FOCO EN LA PESTAÑA DE MARCAS
    this.logger.debug("DEBERÍA ENTRASR EN EL POPUP PONIENDO EL FOCO EN LA PESTAÑA DE MARCAS");
    this.router.navigateByUrl('channelDetail', { state: { canal: item, focus: "marcas" }});
  }

  onItemChange() {
    const selectedItems = this.channelsList.filter(i => i.selected);
    this.logger.debug('Número de ítems seleccionados:', selectedItems.length);
    //HAY DOS O MÁS SELECCIONADOS, POR LO QUE TENGO QUE MOSTRAR LOS BOTONES PARA ACTIVAR O DESACTIVAR VARIOS.
    this.activityButtons =selectedItems.length > 1 ? true : false;
  }


  filterItems(
    event: Event | null,
    elementoFiltrado: string,
    query?: string
  ): void {

    this.currentPage = 1;
    this.pageNumber = 0;

    const searchQuery =
      query ??
      (event?.target as HTMLInputElement)?.value?.toLowerCase() ??
      '';

    this.findByFilter(
      null,
      elementoFiltrado,
      searchQuery
    );
  }

  findByFilter(
    event: any,
    elementoFiltrado: string,
    query?: string
  ) {
    const searchQuery =
      query ??
      event?.target?.value?.toLowerCase() ??
      '';

    const contractSearch = {
      page: this.pageNumber,
      pageSize: this.filterRecords
    };


    this.administracionService
      .findByFilters(
        elementoFiltrado,
        searchQuery,
        contractSearch,
        null,
        null
      )
      .subscribe({
        next: (resp: ChannelListResponse) => {

          this.logger.debug('Filtro:', searchQuery);
          this.logger.debug('Respuesta:', resp);

          if (resp.data?.content) {
            this.channelsList = resp.data.content
              .filter(
                (item: { interno?: boolean }) => !item.interno
              )
              .map(
                (item: { logo?: string }) => ({
                  ...item,
                  logo:
                    item.logo ||
                    'assets/icons/icono_no_icono.png'
                })
              );
            this.sortChannels();
          } else {
            this.channelsList = [];
          }

          this.totalRecords =
            resp.data?.totalElements ?? 0;

        },
        error: (error: any) => {
          this.logger.debug(error);
        }
      });
  }

  createChannel() {
    this.logger.debug('Crear cupón clicado');
    this.router.navigateByUrl('channelDetail', { state: { canal: null } });
  }

  // Función para ordenar
  changeSort(property: string) {
    this.optionSort = {
      property,
      order: this.optionSort.property === property && this.optionSort.order === 'asc'
        ? 'desc'
        : 'asc'
    };
    this.sortChannels();
  }

  private sortChannels(): void {
    const { property, order } = this.optionSort;

    if (!property) {
      return;
    }

    this.channelsList = [...this.channelsList].sort((a, b) => {
      const valueA = a[property];
      const valueB = b[property];

      if (valueA == null || valueB == null) {
        return valueA == null ? (valueB == null ? 0 : 1) : -1;
      }

      const comparison = typeof valueA === 'string' && typeof valueB === 'string'
        ? valueA.localeCompare(valueB, 'es', { sensitivity: 'base' })
        : Number(valueA) - Number(valueB);

      return order === 'asc' ? comparison : -comparison;
    });
  }


  getShowMenu(e: any) {
    this.sideMenuVisible = e;
  }

  getCloseMenu(e: any) {
    this.sideMenuVisible = e;
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.pageNumber = page - 1;

    this.findByFilter(null, 'channels', this.filterValue);
  }

  onItemsPerPageChange(rows: number): void {

    this.filterRecords = rows;
    this.currentPage = 1;
    this.pageNumber = 0;

    this.findByFilter(null, 'channels', this.filterValue);
  }


}
